// extracted by mini-css-extract-plugin
module.exports = {"todayLogo":"todayLogo___1nwgP","logo":"logo___2ZPCG","white":"white___1xlyy","black":"black___1TJv6","active":"active___sj4sR","sunrise":"sunrise___1pSuo"};